import { useState } from "react"
import styled from "styled-components"
import * as PropTypes from "prop-types"
import Typography from "components/styled/Typography"
import Question from "components/Question"
import Icon from "components/icons/icon"
import Arrow from "components/icons/arrow"

const Wrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.silver};
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ last, theme }) => (last ? `border-bottom: 1px solid ${theme.colors.silver};` : null)}
`

const Title = styled(Typography)`
  margin: 0;
`

const StyledIcon = styled(Icon)`
  transform: rotate(0deg);
  transition: transform 0.25s ease-out;
  &.active {
    transform: rotate(90deg);
    transition: transform 0.25s ease-in;
  }
`

const Questions = styled.div`
  background: white;
  padding: 0 10px;
  max-height: 0;
  transition: max-height 0.25s ease-out;
  overflow: hidden;
  &.active {
    max-height: 100%;
    transition: max-height 0.35s ease-in;
    ${({ last, theme }) => (last ? `border-bottom: 1px solid ${theme.colors.silver};` : null)}
  }
`

export default function Block({ item, last }) {
  const { title, list } = item
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <Wrapper onClick={() => setIsOpen(s => !s)} last={last}>
        <Title variant="title3" weight="medium" space>
          {title}
        </Title>
        <StyledIcon size="xs" color="deepPink" className={isOpen ? "active" : null} Icon={Arrow} />
      </Wrapper>
      <Questions className={isOpen ? "active" : null} last={last}>
        {list.map(q => (
          <Question key={q.id} item={q} />
        ))}
      </Questions>
    </>
  )
}

Block.propTypes = {
  item: PropTypes.object.isRequired,
  last: PropTypes.bool.isRequired
}
